import { dew as _constantsDew } from "../constants";
import { dew as _resultsDew } from "../../../results";
import * as _dayjs2 from "dayjs";
var _dayjs = "default" in _dayjs2 ? _dayjs2.default : _dayjs2;
import { dew as _AbstractParserWithWordBoundaryDew } from "../../../common/parsers/AbstractParserWithWordBoundary";
import { dew as _patternDew } from "../../../utils/pattern";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const constants_1 = _constantsDew();
  const results_1 = _resultsDew();
  const dayjs_1 = __importDefault(_dayjs);
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const pattern_1 = _patternDew();
  const PATTERN = new RegExp(`(в прошлом|на прошлой|на следующей|в следующем|на этой|в этом)\\s*(${pattern_1.matchAnyPattern(constants_1.TIME_UNIT_DICTIONARY)})(?=\\s*)${constants_1.REGEX_PARTS.rightBoundary}`, constants_1.REGEX_PARTS.flags);
  const MODIFIER_WORD_GROUP = 1;
  const RELATIVE_WORD_GROUP = 2;
  class RURelativeDateFormatParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    patternLeftBoundary() {
      return constants_1.REGEX_PARTS.leftBoundary;
    }
    innerPattern() {
      return PATTERN;
    }
    innerExtract(context, match) {
      const modifier = match[MODIFIER_WORD_GROUP].toLowerCase();
      const unitWord = match[RELATIVE_WORD_GROUP].toLowerCase();
      const timeunit = constants_1.TIME_UNIT_DICTIONARY[unitWord];
      if (modifier == "\u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0439" || modifier == "\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C") {
        const timeUnits = {};
        timeUnits[timeunit] = 1;
        return results_1.ParsingComponents.createRelativeFromReference(context.reference, timeUnits);
      }
      if (modifier == "\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u043C" || modifier == "\u043D\u0430 \u043F\u0440\u043E\u0448\u043B\u043E\u0439") {
        const timeUnits = {};
        timeUnits[timeunit] = -1;
        return results_1.ParsingComponents.createRelativeFromReference(context.reference, timeUnits);
      }
      const components = context.createParsingComponents();
      let date = dayjs_1.default(context.reference.instant);
      if (timeunit.match(/week/i)) {
        date = date.add(-date.get("d"), "d");
        components.imply("day", date.date());
        components.imply("month", date.month() + 1);
        components.imply("year", date.year());
      } else if (timeunit.match(/month/i)) {
        date = date.add(-date.date() + 1, "d");
        components.imply("day", date.date());
        components.assign("year", date.year());
        components.assign("month", date.month() + 1);
      } else if (timeunit.match(/year/i)) {
        date = date.add(-date.date() + 1, "d");
        date = date.add(-date.month(), "month");
        components.imply("day", date.date());
        components.imply("month", date.month() + 1);
        components.assign("year", date.year());
      }
      return components;
    }
  }
  exports.default = RURelativeDateFormatParser;
  //# sourceMappingURL=RURelativeDateFormatParser.js.map
  return exports;
}